<template>
  <div class="home">
    <van-nav-bar :title="title" fixed>
      <template #right>
        <van-icon name="plus" size="18" @click="Add" />
      </template>
    </van-nav-bar>
    <div class="center-box">
      <van-list :finished="finished" :immediate-check="false" loading-text="加载中..." finished-text="没有更多了" offset="80"
        @load="initTable" class="list-box">
        <div v-for="(item, index) in list" :key="index" class="list-cell">
          <div class="list-cell-header">
            <div class="cell-header-left van-ellipsis">{{ item[tableConfig.rowList[0].model] }}</div>
          </div>
          <div class="list-cell-main">
            <div class="cell-main-tag">
              <DesignTableColumn v-for="colItem in tableConfig.rowList" :key="colItem.key" :rowModel="item"
                :configModel="colItem"></DesignTableColumn>
                <StatusColumn v-if="templateModel.config.needCheck" :status="item.checkStatus"></StatusColumn>
            </div>
          </div>
          <div class="list-cell-footer">
            <van-button size="small" type="info" class="footer-button" @click="Edit(item)"
              v-if="!templateModel.config.needCheck || item.checkStatus==0">
              修改
            </van-button>
            <van-button size="small" type="info" class="footer-button color-red" @click="Delete(item)"
              v-if="!templateModel.config.needCheck || item.checkStatus==0">
              删除
            </van-button>
            <OAButton  :guid="item.guid" v-if="templateModel.config.needCheck && item.checkStatus!=0"></OAButton>
          </div>
        </div>
      </van-list>

    </div>
    <FooterBar></FooterBar>
  </div>
</template>

<script>
  import designConfig from '../designConfig.js'
  export default {
    name: 'sDemoSampleList',
    data() {
      return {
        condition: {
          pageSize: 10,
          recordCount: 1,
          currentPage: 0,
          code: "",
          query: {}
        },
        title: "测试Demo",
        list: [],
        // 获得模板详情地址
        templateUrl: designConfig.baseUrl + "/form/template/queryByCode/",
        // 获得列表数据接口
        searchUrl: designConfig.baseUrl + "/form/data/list",
        // 删除接口
        deleteUrl: designConfig.baseUrl + "/form/data/",
        // 模板JSON转化数据
        templateModel: {
          config: {
            needFile: false,
            needCheck: false,
            checkGuid: "",
          }
        },
        // 表格区域对象
        tableConfig: {
          rowList: []
        },
        finished: false
      }

    },
    components: {

    },
    methods: {
      // 开始查询
      search: function() {
        // 重新设置当前页
        this.currentPage = 0;
        // 设置数组为空
        this.list = []
        // 调用方法设置数组
        this.initTable()
      },
      // 获得数组数据
      initTable: function() {
        let that = this
        that.condition.currentPage++
        // let promise = this.$refs.btnSearch.Search();
        // promise.then(() => {
        //   that.$store.commit("reduceSesignLoadCount", "")
        // })
        that.$utils.HttpPost(that.searchUrl, that.condition, function(data) {
          console.log(data);
          let dataList = data.data
          dataList.forEach(function(item) {
            that.list.push(that.$utils.clone(item))
          })
          // 当数组长度大于分页结果总长度后，finish为true
          if (data.pager.recordCount <= that.list.length) {
            that.finished = true
          }
        })
      },
      // 获得模板对象
      getSampleData() {
        let that = this
        // 后面根据地址栏带的表单编码，请求后台
        that.$utils.HttpGet(that.templateUrl + '?code=' + that.condition.code, function(data) {
          let sampleData = JSON.parse(data.data.templateData)
          that.title = data.data.name
          that.templateModel = that.$utils.clone(sampleData)
          // 设置表格区域相关数据
          that.tableConfig = that.$designUtils.setTableConfig(sampleData)
          // 获得表格展示列
          let rowList = sampleData.allList.filter(t => sampleData.config.showList.includes(t.model))
          // 获得所有需要远程的数据列
          let remoteColumnList = rowList.filter(m => m.options.hasOwnProperty("dynamic") && m.options.dynamic)
          // 设置当前列表页面需要加载的远程请求数量 +1 是因为需要加载table本来的数据
          let designLoadCount = remoteColumnList.length + 1
          that.$store.commit("setDesignLoadCount", designLoadCount)
          // 初始化数组
          that.initTable()
        })
      },
      // 新增
      Add: function() {
        let that = this
        // 新增页面，将页面code通过query传递
        that.$router.push({
          name: "sDemoSampleForm",
          query: {
            code: that.condition.code,
          }
        })
      },
      Edit: function(row) {
        let that = this
        // 新增页面，将页面code通过query传递
        // 传递当前行数据
        that.$router.push({
          name: "sDemoSampleForm",
          query: {
            code: that.condition.code,
          },
          params: row,
        })
      },
      Delete: function(row) {
        let that = this
        //删除接口，两个动态参数，一个是主表Id，一个是要显示的提示信息中文
        that.$utils.DeleteRow(that.deleteUrl + `${that.condition.code}/${row.guid}`, "当前行", that.$refs
          .btnSearch.Search)
      },
    },
    mounted() {
      this.condition.code = this.$route.query.code
      if (this.condition.code) {
        this.getSampleData()
      }
    }
  }
</script>
<style scoped>

</style>
